__webpack_require__.p = "https://r.haier.net/assets/prod/s047911/fe/aiclient-download/1.0.14/";